<template>
  <div class="layout" id="video">
    <h2>聆聽在地音樂故事
    </h2>
    <h3 class="pc">《民視》深度採訪台灣樂團，
      一窺音樂人的精采世界！</h3>
    <h3 class="mb">《民視》深度採訪台灣樂團<br>
      一窺音樂人的精采世界！</h3>
    <swiper class="swiper" :options="swiperOption">

      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023328W0245" target="_blank">
          <div class="swipersection">
            <img src="../assets/滅火器樂團1.jpg" alt="滅火器樂團" loading="lazy">
            <div>
              <p>台灣演義／高雄囝仔「滅火器樂團」唱出台灣人的心聲</p>
            </div>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023328W0261" target="_blank">
          <div class="swipersection">
            <img src="https://www.ftvnews.com.tw/topics/taiwanband/img/閃靈樂團1.jpg" alt="閃靈樂團" loading="lazy">
            <p>台灣演義／閃靈樂團 開創台灣樂團搖滾新視野</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023328W0269" target="_blank">
          <div class="swipersection">
            <img src="../assets/五月天.jpg" alt="五月天" loading="lazy">
            <p>台灣演義／台灣樂團五月天崛起故事</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023328W0281" target="_blank">
          <div class="swipersection">
            <img src="../assets/拍謝少年1.jpg" alt="拍謝少年" loading="lazy">
            <p>夜深人未靜／最台的搖滾樂團 拍謝少年</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2018B01W0007" target="_blank">
          <div class="swipersection">
            <img src="../assets/恆月三途.jpg" alt="恆月三途" loading="lazy">
            <p>樂團組合與音樂創作知多少 看恆月三途的心路歷程</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2018A03W0012" target="_blank">
          <div class="swipersection">
            <img src="../assets/漂流出口.jpg" alt="漂流出口" loading="lazy">
            <p>用音樂找尋真實自我 看漂流出口如何收服粉絲的心</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2017C07W0008" target="_blank">
          <div class="swipersection">
            <img src="../assets/19兩.jpg" alt="19兩" loading="lazy">
            <p>「19兩」11年孵出首張專輯 第一個電視通告獻給他</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2017B01W0006" target="_blank">
          <div class="swipersection">
            <img src="../assets/抒壓.jpg" alt="抒壓" loading="lazy">
            <p>馮光遠、林昶佐大聊「奶爸經」 都靠說故事抒壓</p>
          </div>
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <h3 class="pc">唱頌台灣！金曲歌王朱頭皮帶路，
      帶你認識在地創作人，好聽又好玩！</h3>

    <h3 class="mb">唱頌台灣！金曲歌王朱頭皮帶路<br>
      帶你認識在地創作人，好聽又好玩！</h3>


    <swiper class="swiper" :options="swiperOption">
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023310W0176" target="_blank">
          <div class="swipersection">
            <img src="../assets/朱頭皮.jpg" alt="朱頭皮" loading="lazy">
            <p>《唱頌台灣暢Song世界》金曲歌王朱頭皮重拾主持棒</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2022601W0043" target="_blank">
          <div class="swipersection">
            <img src="../assets/董事長.jpg" alt="董事長" loading="lazy">
            <p>獲邀上朱約信新節目 董事長樂團爆料「黑歷史」</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2022A07W0221" target="_blank">
          <div class="swipersection">
            <img src="../assets/鄭宜農.jpg" alt="鄭宜農" loading="lazy">
            <p>「新世紀的女兒」鄭宜農 首張全台語創作專輯重在溝通</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2022B11W0149" target="_blank">
          <div class="swipersection">
            <img src="../assets/林奕碩.jpg" alt="林奕碩" loading="lazy">
            <p>新科金曲得主百合花 主唱林奕碩曝創作心聲</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023328W0299" target="_blank">
          <div class="swipersection">
            <img src="../assets/裝咖人.jpg" alt="裝咖人" loading="lazy">
            <p>傳統北管X台灣鄉野 新生代台文樂團 裝咖人</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023310W0176" target="_blank">
          <div class="swipersection">
            <img src="../assets/同根生.jpg" alt="漂流出口" loading="lazy">
            <p>同根生樂團帶「豬」上節目唱歌 超狂舉動讓主持人難以招架</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023328W0303" target="_blank">
          <div class="swipersection">
            <img src="../assets/吳志寧.jpg" alt="吳志寧" loading="lazy">
            <p>唱頌台灣／ 叛逆血液化為溫柔旋律 療癒系創作歌手吳志寧</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023203W0177" target="_blank">
          <div class="swipersection">
            <img src="../assets/黃連煜.jpg" alt="黃連煜" loading="lazy">
            <p>金曲歌王黃連煜一度離開新寶島康樂隊 遭老搭檔陳昇嗆這句話</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023113W0201" target="_blank">
          <div class="swipersection">
            <img src="https://www.ftvnews.com.tw/topics/taiwanband/img/%E5%AE%8B%E5%BE%B7%E9%B6%B4.jpg" alt="宋德鶴"
              loading="lazy">
            <p>宋德鶴、飛鴻樂團主唱登場 合作表演迸出新火花</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023328W0314" target="_blank">
          <div class="swipersection">
            <img src="../assets/邱晨.jpg" alt="邱晨" loading="lazy">
            <p>唱頌台灣／民歌跨足搖滾 投身街頭運動 紀念資深音樂人邱晨</p>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="https://www.ftvnews.com.tw/news/detail/2023224W0142" target="_blank">
          <div class="swipersection">
            <img src="../assets/吉他雙雄.jpg" alt="吉他雙雄" loading="lazy">
            <p>吉他雙雄大竹研、董運昌同台飆彈 台日曲風各有千秋</p>
          </div>
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>


<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'swiper-example-navigation',
  title: 'Navigation',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      news: [

      ],
      swiperOption: {
        loop: true,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          3080: {
            slidesPerView: 3,
            spaceBetween: 0
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 0
          },
          700: {
            slidesPerGroup: 2,
            slidesPerView: 2,
            spaceBetween: 0
          },
          500: {
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>


<style scoped>
.swiper {
  margin: auto;
}

.section {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: auto;
  max-width: 1300px;

}

@media screen and (max-width:768px) {
  .section {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }


}

@media screen and (max-width:500px) {
  .section {
    display: flex;
    overflow-x: scroll;
  }



}


.section_left button {
  margin-right: 0rem;
}

.section img {
  border-radius: 1px;
  width: 100%;
  height: 100%;

}




h3 {
  text-align: center;
}

img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border: 2px solid;
}

@media screen and (max-width:700px) {
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    border: 2px solid;
  }
}

@media screen and (max-width:500px) {
  img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    border: 2px solid;
  }
}


p {
  position: relative;
  border: 2px solid;
  bottom: 2rem;
  background-color: rgb(249 214 131);
  width: 100%;
  padding: .3rem auto;
  text-align: center;
  display: flex;
  justify-content: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  margin: 1rem auto;
  font-weight: bold;
  padding-top: 0.5rem;
  padding-bottom: 0.3rem;
}

swiper-slide {
  padding: 100px;

}


.swipersection {
  padding: .5rem;
  margin: auto 1rem;
}

@media screen and (max-width:500px) {
  .swipersection {
    padding: .5rem;
    margin: auto 1.5rem;
  }
}
</style>
